import { HTMLProps, forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = () =>
  createStyles({
    root: {},
  });

export interface SidebarSectionActionProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const SidebarSectionActionMui = forwardRef<
  HTMLDivElement,
  SidebarSectionActionProps
>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <div
      {...rest}
      ref={ref}
      // keep for compatibility with existing e2e tests
      data-testid="action-button"
      className={classNames(className, classes.root)}
    >
      {children}
    </div>
  );
});

SidebarSectionActionMui.displayName = 'SidebarSectionMui.Action';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore SidebarSection and delete. */
export default withStyles(styles)(SidebarSectionActionMui);
